{
  "faq.who-and-when.q": {
    "text": "யார் சேர வேண்டும், எப்போது?",
    "sourceHash": "251bbd2c",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.who-and-when.0": {
    "text": "GST பதிவு பெற்ற ஒவ்வொரு வணிகமும் InvoiceNow-Ready தீர்வுகளைப் பயன்படுத்தி IRAS-க்கு விலைப்பட்டியல் தரவைச் சமர்ப்பிக்க வேண்டும்; இது 1 ஏப்ரல் 2031 வரை கட்டம் கட்டமாக அமலாகிறது.",
    "sourceHash": "9767c883",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.who-and-when.1": {
    "text": "நீங்கள் ஏற்கெனவே GST பதிவு பெற்றிருந்தால், உங்கள் கட்டம் 2025 நாட்காட்டி ஆண்டில் முடிவடையும் நிர்ணயிக்கப்பட்ட கணக்கியல் காலங்களின் மொத்த ஆண்டு விநியோகங்களைப் பொறுத்தது.",
    "sourceHash": "2ee88fe9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.who-and-when.2": {
    "text": "விலக்கப்பட்ட வணிகங்கள் (Excluded Business) மட்டுமே விலக்கு பெறுகின்றன: வெளிநாட்டு நிறுவனங்கள், தலைகீழ் வரி விதிப்பு முறையால் மட்டுமே GST பதிவுசெய்த வணிகங்கள்.",
    "sourceHash": "cee74f72",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.what-is-it.q": {
    "text": "InvoiceNow என்றால் என்ன, GST தேவை என்றால் என்ன?",
    "sourceHash": "05be8990",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.what-is-it.0": {
    "text": "InvoiceNow என்பது சர்வதேச Peppol தரநிலையை அடிப்படையாகக் கொண்ட சிங்கப்பூரின் தேசிய மின்-விலைப்பட்டியல் வலையமைப்பு.",
    "sourceHash": "fc70514e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.what-is-it.1": {
    "text": "GST InvoiceNow Requirement-இன் கீழ், GST பதிவு பெற்ற வணிகங்கள் InvoiceNow-Ready தீர்வுகளைப் பயன்படுத்தி IRAS-க்கு விலைப்பட்டியல் தரவைச் சமர்ப்பிக்க வேண்டும்.",
    "sourceHash": "eecafed8",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.what-is-it.2": {
    "text": "மின்னஞ்சல் மூலம் PDF விலைப்பட்டியல்களை அனுப்புவதும் பெறுவதும் மின்-விலைப்பட்டியல் அல்ல.",
    "sourceHash": "a3355442",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.is-it-free.q": {
    "text": "இது இலவசமா? மானியங்கள் உண்டா?",
    "sourceHash": "4a32a5cd",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.is-it-free.0": {
    "text": "IMDA-வின் இலவச (FOC) InvoiceNow தொகுப்புப் பட்டியலின்படி, முழுத் தீர்வுத் தொகுப்பும் எந்த நிபந்தனையும் இன்றி இலவசம்.",
    "sourceHash": "e0c56a40",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.is-it-free.1": {
    "text": "GST பதிவு பெற்ற வணிகங்களுக்கான இலவசத் தொகுப்புகள் 31 மார்ச் 2031 வரை கிடைக்கும்.",
    "sourceHash": "ef4224e2",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.is-it-free.2": {
    "text": "தொடக்க, முடிவுத் தேதிகள் வழங்குநருக்கு வழங்குநர் மாறுபடும்; நீங்கள் தேர்ந்தெடுக்கும் தொகுப்புக்குப் பட்டியலைச் சரிபாருங்கள்.",
    "sourceHash": "c6294c6d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.is-it-free.3": {
    "text": "மானியங்களில் அடங்குபவை: S$4 மில்லியன் வரை மொத்த ஆண்டு விநியோகமுள்ள வணிகங்களுக்கு S$1,000 Transition Grant, தங்கள் சொந்த ERP-ஐ இணைக்கும் பெரிய வணிகங்களுக்கு S$5,000 Transition Grant, S$25,000 Queen Bee Grant.",
    "sourceHash": "f1558d4b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.is-it-free.4": {
    "text": "தகுதியான மென்பொருள் சந்தாச் செலவுகளில் 50% வரை ஈடுசெய்ய, சிறு, நடுத்தர நிறுவனங்கள் (SME) Productivity Solutions Grant-ஐயும் பயன்படுத்தலாம்.",
    "sourceHash": "d6dd2dfc",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.partners-not-on-invoicenow.q": {
    "text": "என் வாடிக்கையாளர்கள் InvoiceNow-வில் இல்லையென்றால் என்ன?",
    "sourceHash": "e540e56d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.partners-not-on-invoicenow.0": {
    "text": "நீங்கள் இன்னும் இணங்க வேண்டும். வலையமைப்புக்கு வெளியே வழங்கப்படும் விற்பனை விலைப்பட்டியல்கள், தீர்வு பிரித்தெடுத்த விலைப்பட்டியல்களாக (Type 2) IRAS-க்குச் சமர்ப்பிக்கப்படுகின்றன; உங்கள் InvoiceNow-Ready தீர்வு அவற்றைத் தானாகவே குறிப்பிட்ட கால இடைவெளியில் பிரித்தெடுத்து அனுப்புகிறது.",
    "sourceHash": "a6b5e467",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.partners-not-on-invoicenow.1": {
    "text": "வாடிக்கையாளரின் பெயர், UEN, முகவரி ஆகியவை கட்டாயத் தரவு உறுப்புகள் என்பதால், அவற்றை நீங்கள் இன்னும் சேகரிக்க வேண்டும். வெளிநாட்டு வாடிக்கையாளர்களுக்கு, அவர்களின் வெளிநாட்டு வணிகப் பதிவு எண்ணை Customer UEN ஆகப் பயன்படுத்துங்கள்.",
    "sourceHash": "ec014db2",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.partners-not-on-invoicenow.2": {
    "text": "GST பதிவு பெறாத தனிநபர் வாடிக்கையாளர்களுக்கு, Customer Name, Customer UEN ஆகிய இரண்டு புலங்களிலும் \"NA\" என இடலாம்.",
    "sourceHash": "9d4ff1ab",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.partners-not-on-invoicenow.3": {
    "text": "வாடிக்கையாளர் விவரங்களை நீங்கள் சரிபார்க்க வேண்டியதில்லை; ஆனால் அவற்றை ஆதரிக்கும் பதிவேடுகளை வைத்திருங்கள்.",
    "sourceHash": "5ef1d019",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.partners-not-on-invoicenow.4": {
    "text": "Access Point வழங்குநர்களால் PDF அல்லது காகித விலைப்பட்டியல்களை Peppol வடிவத்துக்கு மாற்ற முடியாது.",
    "sourceHash": "9a74f877",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.non-compliance.q": {
    "text": "எனக்கு விலக்கு கிடைக்குமா, அல்லது விலகிக்கொள்ள முடியுமா?",
    "sourceHash": "eec59ad2",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.non-compliance.0": {
    "text": "விலகிக்கொள்ள வழியில்லை: விலக்கப்பட்ட வணிகங்கள் (Excluded Business) தவிர GST பதிவு பெற்ற அனைத்து வணிகங்களும் இணங்க வேண்டும்.",
    "sourceHash": "6dc42750",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.non-compliance.1": {
    "text": "தொடர்புடைய நிறுவனங்களுக்கு மட்டுமே விநியோகிக்கும் வணிகங்கள், சிறிய அல்லது குறைந்த பரிவர்த்தனை கொண்ட வணிகங்கள், பூஜ்ஜிய வீத அல்லது விலக்கு பெற்ற விநியோகங்களை மட்டுமே செய்யும் வணிகங்கள் விலக்கு பெற முடியாது என்று IRAS கூறுகிறது.",
    "sourceHash": "767e74af",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.non-compliance.2": {
    "text": "உங்கள் வணிகம், கூடுதல் காலம் தேவைப்படும் ERP அமைப்பைப் பகிர்ந்துகொள்ளும் உரிமை வணிகக் (franchise) குழு போன்ற வணிக ஏற்பாட்டின் பகுதியாக இருந்தால், பிந்தைய நடைமுறைத் தேதி கோரி IRAS-க்கு எழுதலாம். IRAS ஒவ்வொரு கோரிக்கையையும் தனித்தனியாகப் பரிசீலிக்கிறது.",
    "sourceHash": "0b296961",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.penalties.q": {
    "text": "அபராதங்கள் என்ன, IRAS எவ்வளவு கண்டிப்பாக இருக்கும்?",
    "sourceHash": "3dbc8ace",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.penalties.0": {
    "text": "அலட்சியத்தால் அல்லாத, நியாயமான காரணமின்றிச் செய்யப்படாத, விலைப்பட்டியல் தரவில் உள்ள உண்மையான தவறுகளுக்கு, தொடக்கக் கட்டங்களில் தனது அமலாக்க அணுகுமுறையைச் சரிசெய்யும் என்று IRAS கூறுகிறது.",
    "sourceHash": "42096166",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.penalties.1": {
    "text": "1 ஏப்ரல் 2031-க்குள் மீதமுள்ள GST பதிவு பெற்ற அனைத்து வணிகங்களும் இணங்க வேண்டும்; இணங்காத வணிகங்கள் மீது அமலாக்க நடவடிக்கை எடுக்கப்படலாம்.",
    "sourceHash": "655f4a55",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.penalties.2": {
    "text": "1 நவம்பர் 2025 முதல் நீங்கள் தன்னார்வமாகப் பதிவுசெய்து இணங்கவில்லை என்றால், உங்கள் விண்ணப்பம் நிராகரிக்கப்படலாம் அல்லது உங்கள் பதிவு ரத்து செய்யப்படலாம்.",
    "sourceHash": "f9f72473",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.penalties.3": {
    "text": "உங்கள் விலைப்பட்டியல் தரவு உங்கள் GST அறிக்கையுடன் பொருந்துகிறதா என்று சரிபார்க்க வேண்டும்; ஆனால் நியாயமான வேறுபாடுகள் (நேர வேறுபாடு, விலைப்பட்டியல் தேவையில்லாத விநியோகங்கள், முழுமையாகக் கோரப்படாத உள்ளீட்டு வரி போன்றவை), நீங்கள் பதிவேடுகளை வைத்திருந்து கேட்கும்போது காட்ட முடிந்தால், அபராதத்துக்கு உள்ளாகாது.",
    "sourceHash": "cb6f8153",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.pos-aggregated.q": {
    "text": "நான் POS அல்லது பணப் பதிவேடு மூலம் விற்கிறேன். எனக்கு Peppol விலைப்பட்டியல் தேவையா?",
    "sourceHash": "2124fbf0",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.pos-aggregated.0": {
    "text": "இல்லை. POS விற்பனைக்கு, Peppol விலைப்பட்டியல் வழங்காமலேயே வாடிக்கையாளர்களுக்குத் தொடர்ந்து ரசீதுகள் தரலாம்.",
    "sourceHash": "1a55e4f4",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.pos-aggregated.1": {
    "text": "விற்பனைத் தரவை நீங்கள் இன்னும் IRAS-க்குச் சமர்ப்பிக்க வேண்டும். POS விற்பனையைத் தொகுத்துப் பதிவுசெய்யலாம்; தொகுக்கப்பட்ட தரவு தீர்வு பிரித்தெடுத்த விலைப்பட்டியல்களாக அனுப்பப்படும்.",
    "sourceHash": "059e5f23",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.pos-aggregated.2": {
    "text": "POS விநியோகங்கள், எளிய வரி விலைப்பட்டியல் அல்லது ரசீது வழங்கப்படும் விநியோகங்கள், பணியாளர் கோரிக்கைகள், நிறுவன அட்டைக் கொள்முதல்கள் போன்ற சில்லறைப் பணக் கொள்முதல்கள் ஆகியவற்றைத் தொகுக்க அனுமதி உண்டு.",
    "sourceHash": "30250c9b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.pos-aggregated.3": {
    "text": "உங்கள் POS அமைப்பை எப்படி ஒருங்கிணைக்கலாம் என்று உங்கள் InvoiceNow-Ready தீர்வு வழங்குநரிடம் கேளுங்கள்.",
    "sourceHash": "4c379c26",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.deadline.q": {
    "text": "விலைப்பட்டியல் தரவைச் சமர்ப்பிப்பதற்கான காலக்கெடு எப்போது?",
    "sourceHash": "0ca198b7",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.deadline.0": {
    "text": "அனைத்து விலைப்பட்டியல் தரவும், தொடர்புடைய GST அறிக்கையை நீங்கள் தாக்கல் செய்யும் தேதி, அல்லது அந்த அறிக்கையின் தாக்கல் காலக்கெடு, இவற்றில் எது முந்தையதோ அதற்குள் IRAS-ஐ அடைய வேண்டும்.",
    "sourceHash": "801941ca",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.deadline.1": {
    "text": "தொடர்புடைய GST அறிக்கை என்பது, பரிவர்த்தனை நிகழும் கணக்கியல் காலத்தை உள்ளடக்கும் அறிக்கை.",
    "sourceHash": "9c3a59aa",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.deadline.2": {
    "text": "Peppol விலைப்பட்டியல்கள் (Type 1A) பொதுவாக நிகழ்நேரத்தில் அல்லது ஏறக்குறைய நிகழ்நேரத்தில் IRAS-ஐ அடைகின்றன. தீர்வு பிரித்தெடுத்த சமர்ப்பிப்புகளை (Types 1B, 2, 3) உங்கள் தீர்வு மூலம் வழக்கமான இடைவெளியில் திட்டமிடலாம்.",
    "sourceHash": "c28259ca",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.acknowledgement.q": {
    "text": "என் சமர்ப்பிப்பு வெற்றிபெற்றது என்று எப்படித் தெரியும்?",
    "sourceHash": "d60095a3",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.acknowledgement.0": {
    "text": "ஒவ்வொரு வெற்றிகரமான அனுப்புதலுக்கும், உங்கள் InvoiceNow-Ready தீர்வு மூலம் IRAS-இடமிருந்து ஒப்புகை எண் (acknowledgement ID) பெறுவீர்கள். IRAS சமர்ப்பிப்பைப் பெற்றதை அது உறுதிப்படுத்துகிறது.",
    "sourceHash": "a8751f73",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.acknowledgement.1": {
    "text": "ஒவ்வொரு சமர்ப்பிப்பின் தேதி, நேரம், நிலை, IRAS ஒப்புகை எண் ஆகியவற்றைப் பார்க்க InvoiceNow-Ready தீர்வு வழங்குநர்கள் உங்களை அனுமதிக்க வேண்டும். இது காட்டப்படும் விதம் வழங்குநருக்கு வழங்குநர் மாறுபடும்.",
    "sourceHash": "27207ce6",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.resubmissions.q": {
    "text": "திருத்தங்கள், மீண்டும் சமர்ப்பித்தல், கடன் குறிப்புகள் எப்படிச் செயல்படுகின்றன?",
    "sourceHash": "da88dfe8",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.resubmissions.0": {
    "text": "உங்கள் தீர்வில் ஒரு விலைப்பட்டியல் பதிவைத் திருத்தினால், எடுத்துக்காட்டாக அதன் GST வகைக் குறியீட்டை, விலைப்பட்டியல் தரவை மீண்டும் சமர்ப்பிக்க வேண்டும். கடைசிச் சமர்ப்பிப்பையே IRAS சமீபத்திய பதிவாகக் கருதுகிறது.",
    "sourceHash": "497f109f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.resubmissions.1": {
    "text": "கொள்முதல் தரவைச் சமர்ப்பித்தபோது இறுதி உள்ளீட்டு வரி நடைமுறையை உங்களால் அறிய முடியவில்லை என்றால், விலைப்பட்டியல் மதிப்பு மாறாதபோது, பின்னோக்கிய சரிசெய்தல்களை நீங்கள் செய்ய வேண்டியதில்லை. உங்கள் நடைமுறையை ஆதரிக்கப் பதிவேடுகளை வைத்திருங்கள்.",
    "sourceHash": "daf5c6fc",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.resubmissions.2": {
    "text": "இந்தத் தேவை இரண்டு ஆவண வகைகளை ஆதரிக்கிறது: விலைப்பட்டியல்கள், கடன் குறிப்புகள். GST தொகை சரிசெய்யப்படாவிட்டாலும், மூல விலைப்பட்டியலின் அதே GST வகைக் குறியீட்டைப் பயன்படுத்திக் கடன் குறிப்புத் தரவைச் சமர்ப்பிக்க வேண்டும்.",
    "sourceHash": "368b8074",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.resubmissions.3": {
    "text": "விநியோக முகவரி போன்ற, பண மதிப்பைப் பாதிக்காத மாற்றங்களுக்கு, விற்பனையாளர் அதே Document UUID உடன் திருத்திய விலைப்பட்டியலை அனுப்புகிறார்; இல்லையென்றால் விற்பனையாளர் கடன் குறிப்பை வழங்குகிறார்.",
    "sourceHash": "a734bebb",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.group-registration.q": {
    "text": "நாங்கள் ஒரு GST குழு. இது எப்படிப் பொருந்தும்?",
    "sourceHash": "4942fb86",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.group-registration.0": {
    "text": "GST குழுவில் உள்ள நிறுவனங்கள் இன்னும் ஒரே ஒருங்கிணைந்த GST அறிக்கையைத் தாக்கல் செய்கின்றன. விலைப்பட்டியல் தரவை ஒவ்வொரு நிறுவனமும் தனியாகவோ, குழுப் பிரதிநிதி ஒருங்கிணைத்தோ அனுப்பலாம்.",
    "sourceHash": "bd0a81d0",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.group-registration.1": {
    "text": "ஏற்கெனவே உள்ள GST குழுவில் சேர்க்கப்படும் புதிய தன்னார்வ GST பதிவாளர், அந்தக் குழுவின் கட்டத்தைப் பின்பற்றுகிறார்.",
    "sourceHash": "ef5c81ea",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.group-registration.2": {
    "text": "குழுவில் உள்ள ஒரு நிறுவனம் வெளிநாட்டு நிறுவனம் போன்ற விலக்கப்பட்ட வணிகமாக (Excluded Business) இருந்தால், அந்த நிறுவனம் மட்டுமே விலைப்பட்டியல் தரவை அனுப்ப வேண்டியதில்லை.",
    "sourceHash": "beaab745",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.what-data.q": {
    "text": "IRAS என்ன தரவைப் பெறுகிறது?",
    "sourceHash": "4e75adb1",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.what-data.0": {
    "text": "நிலையான வீத, பூஜ்ஜிய வீத விநியோகங்கள், கொள்முதல்கள், விலக்கு பெற்ற விநியோகங்கள் ஆகியவற்றுக்கான விலைப்பட்டியல் தரவு; விலைப்பட்டியல்கள், ரசீதுகள், பற்றுக் குறிப்புகள், கடன் குறிப்புகளிலிருந்து.",
    "sourceHash": "8c9b975f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.what-data.1": {
    "text": "விற்பனை முனைய விநியோகங்கள், எளிய வரி விலைப்பட்டியல்கள் கொண்ட விநியோகங்கள், சில்லறைப் பணக் கொள்முதல்கள் ஆகியவற்றைச் சமர்ப்பிக்கும் முன் தொகுக்கலாம்.",
    "sourceHash": "920fcacd",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.what-data.2": {
    "text": "ஏதேனும் கட்டாயத் தரவு உறுப்பு இல்லாத தரவு தானாகவே நிராகரிக்கப்படும்.",
    "sourceHash": "e392af3d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.what-data.3": {
    "text": "ஆதார ஆவணங்கள் சமர்ப்பிக்கப்படுவதில்லை; ஆனால் அவற்றை வைத்திருந்து, IRAS கேட்டால் வழங்க வேண்டும்.",
    "sourceHash": "afd78d28",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.purchases.q": {
    "text": "கொள்முதல் விலைப்பட்டியல்களும் கணக்கில் வருமா?",
    "sourceHash": "4f12cfc1",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.purchases.0": {
    "text": "ஆம், நீங்கள் கோரும் உள்ளீட்டு வரியை ஆதரிக்கும் நிலையான வீத, பூஜ்ஜிய வீதக் கொள்முதல்களுக்கு.",
    "sourceHash": "7672e819",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.purchases.1": {
    "text": "உள்ளீட்டு வரி கோர வேண்டாம் என்று நீங்கள் தேர்ந்தெடுக்கும் கொள்முதல்கள் இந்தத் தேவைக்கு வெளியே உள்ளன; ஆனாலும் அவற்றை \"OP\" வகைக் குறியீட்டுடன் அனுப்பலாம்.",
    "sourceHash": "80e73039",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.customer-not-registered.q": {
    "text": "என் வாடிக்கையாளர் GST பதிவு பெறவில்லை. நான் இன்னும் தரவை அனுப்ப வேண்டுமா?",
    "sourceHash": "4eab912b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.customer-not-registered.0": {
    "text": "ஆம். உங்கள் வாடிக்கையாளரின் GST நிலை எதுவாக இருந்தாலும், அவர்கள் உள்ளீட்டு வரி கோரினாலும் கோராவிட்டாலும், தேவையின் வரம்புக்குள் வரும் விலைப்பட்டியல் தரவை அனுப்ப வேண்டும்.",
    "sourceHash": "09a40f29",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.customer-not-registered.1": {
    "text": "GST பதிவு பெறாத தனிநபர் வாடிக்கையாளர்களுக்கு, Customer Name, Customer UEN புலங்களில் \"NA\" என இடலாம்.",
    "sourceHash": "0fc67bce",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.software-ready.q": {
    "text": "என் தற்போதைய மென்பொருள் தயாரா? இல்லையென்றால் என்ன?",
    "sourceHash": "eacb23c9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.software-ready.0": {
    "text": "IMDA அங்கீகாரம் பெற்ற InvoiceNow-Ready தீர்வு வழங்குநர் பட்டியலைச் சரிபாருங்கள். உங்களுடையது அதில் இல்லையென்றால், அதை இணைக்க IMDA அங்கீகாரம் பெற்ற Access Point வழங்குநருடன் பணியாற்றலாம், இலவசத் தொகுப்புக்கு மாறலாம், அல்லது InvoiceNow-Ready தீர்வுக்கு மாறலாம்.",
    "sourceHash": "60964d32",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.software-ready.1": {
    "text": "நீங்கள் ERP அமைப்பைப் பயன்படுத்தினால், நேரடியாகவோ உங்கள் அமைப்பு ஒருங்கிணைப்பாளர் மூலமோ IMDA அங்கீகாரம் பெற்ற Access Point வழங்குநர் தேவை.",
    "sourceHash": "e3b2bf8c",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.access-point.q": {
    "text": "Access Point என்றால் என்ன, எனக்கு அது தேவையா?",
    "sourceHash": "ac631798",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.access-point.0": {
    "text": "Access Point (அணுகல் முனையம்) வழங்குநர்கள் InvoiceNow வலையமைப்பில் நுழைவாயில்களை இயக்கி, விலைப்பட்டியல்களைச் சரியான இடத்துக்கு அனுப்புகிறார்கள்.",
    "sourceHash": "a247f1a9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.access-point.1": {
    "text": "InvoiceNow-Ready தீர்வு வழங்குநர்கள், அங்கீகாரம் பெற்ற Access Point மூலம் ஏற்கெனவே இணைக்கப்பட்ட மென்பொருளை வழங்குகிறார்கள்.",
    "sourceHash": "b329ef94",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.access-point.2": {
    "text": "உங்கள் சொந்த அமைப்பையோ API-யையோ இணைக்க, IMDA அங்கீகாரம் பெற்ற Access Point வழங்குநர் மூலம் செல்ல வேண்டும்.",
    "sourceHash": "404063b5",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.safety-and-returns.q": {
    "text": "என் தரவு பாதுகாப்பானதா? நான் இன்னும் GST அறிக்கைகளைத் தாக்கல் செய்ய வேண்டுமா?",
    "sourceHash": "0f62bc53",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.safety-and-returns.0": {
    "text": "IMDA அங்கீகாரம் பெற்ற Access Point வழங்குநர்கள் மட்டுமே வலையமைப்பில் இயங்குகிறார்கள்; தரவு அனுப்பப்படும்போது மறையாக்கப்பட்டு, மின்னிலக்கக் கையொப்பமிடப்படுகிறது.",
    "sourceHash": "ebff2042",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.safety-and-returns.1": {
    "text": "தான் பெறும் விலைப்பட்டியல் தரவு தொடர்பாக IRAS ரகசியக் காப்புச் சட்டங்களுக்குக் கட்டுப்பட்டது.",
    "sourceHash": "8e913252",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.safety-and-returns.2": {
    "text": "நீங்கள் இன்னும் GST அறிக்கைகளைத் தாக்கல் செய்து, மூல ஆவணங்கள் உட்பட பதிவேடுகளைக் குறைந்தது 5 ஆண்டுகள் வைத்திருக்க வேண்டும்.",
    "sourceHash": "fef52c95",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "phase.p1.who": {
    "text": "நிறுவப்பட்ட 6 மாதங்களுக்குள் தன்னார்வ GST பதிவுக்கு விண்ணப்பிக்கும் புதிதாக நிறுவப்பட்ட நிறுவனங்கள்",
    "sourceHash": "c42e068e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "phase.p2.who": {
    "text": "1 ஏப்ரல் 2026 அன்றோ அதற்குப் பிறகோ தன்னார்வ GST பதிவுக்கு விண்ணப்பிக்கும் எந்த வணிகமும்",
    "sourceHash": "a972bbdc",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "phase.p3.who": {
    "text": "1 ஏப்ரல் 2028 அன்றோ அதற்குப் பிறகோ கட்டாய GST பதிவுக்கு விண்ணப்பிக்கும் வணிகங்கள், மொத்த ஆண்டு விநியோகங்கள் ≤ S$200,000 உள்ள தற்போதைய பதிவாளர்கள்",
    "sourceHash": "320d3e46",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "phase.p4.who": {
    "text": "மொத்த ஆண்டு விநியோகங்கள் ≤ S$1,000,000 உள்ள தற்போதைய பதிவாளர்கள்",
    "sourceHash": "247ce82c",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "phase.p5.who": {
    "text": "மொத்த ஆண்டு விநியோகங்கள் ≤ S$4,000,000 உள்ள தற்போதைய பதிவாளர்கள்",
    "sourceHash": "00be1d53",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "phase.p6.who": {
    "text": "மொத்த ஆண்டு விநியோகங்கள் > S$4,000,000 உள்ள தற்போதைய பதிவாளர்கள்",
    "sourceHash": "0cb8bb21",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "when.totalAnnualSupplies": {
    "text": "மொத்த ஆண்டு விநியோகங்கள் என்பது, 2025 நாட்காட்டி ஆண்டில் முடிவடையும் அனைத்து நிர்ணயிக்கப்பட்ட கணக்கியல் காலங்களிலும் செய்யப்பட்ட நிலையான வீத, பூஜ்ஜிய வீத, விலக்கு பெற்ற விநியோகங்களின் மொத்த மதிப்பு (GST அறிக்கையின் பெட்டி 4).",
    "sourceHash": "8894df11",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "when.myTaxMail": {
    "text": "2026-க்கு முன் பதிவுசெய்த GST வணிகங்களுக்கு, 2026 நடுப்பகுதி முதல் அவற்றின் கட்டாய நடைமுறைத் தேதியை IRAS அறிவித்துள்ளது. 2025-இல் முடிவடையும் காலங்களுக்கான GST அறிக்கைகள் இல்லாத வணிகங்களுக்கு, அவற்றின் தேதி பின்னர் தெரிவிக்கப்படும்.",
    "sourceHash": "64e720e6",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.window.mar-jun-sep-dec": {
    "text": "உங்கள் காலங்கள் மார்ச், ஜூன், செப்டம்பர், டிசம்பர் மாதங்களில் முடிவடைந்தால், ஜனவரி 2025 முதல் டிசம்பர் 2025 வரையிலான விநியோகங்களைக் கூட்டுங்கள்.",
    "sourceHash": "fa00a218",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.window.jan-apr-jul-oct": {
    "text": "உங்கள் காலங்கள் ஜனவரி, ஏப்ரல், ஜூலை, அக்டோபர் மாதங்களில் முடிவடைந்தால், நவம்பர் 2024 முதல் அக்டோபர் 2025 வரையிலான விநியோகங்களைக் கூட்டுங்கள்.",
    "sourceHash": "11796ab6",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.window.feb-may-aug-nov": {
    "text": "உங்கள் காலங்கள் பிப்ரவரி, மே, ஆகஸ்ட், நவம்பர் மாதங்களில் முடிவடைந்தால், டிசம்பர் 2024 முதல் நவம்பர் 2025 வரையிலான விநியோகங்களைக் கூட்டுங்கள்.",
    "sourceHash": "90c6363c",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.window.monthly": {
    "text": "மொத்த ஆண்டு விநியோகங்கள், 2025 நாட்காட்டி ஆண்டில் முடிவடையும் அனைத்து நிர்ணயிக்கப்பட்ட கணக்கியல் காலங்களையும் உள்ளடக்கும்.",
    "sourceHash": "1f16e3b1",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.reason.sum": {
    "text": "மொத்த ஆண்டு விநியோகங்கள் என்பவை, 2025 நாட்காட்டி ஆண்டில் முடிவடையும் அனைத்து நிர்ணயிக்கப்பட்ட கணக்கியல் காலங்களிலும் செய்யப்பட்ட நிலையான வீத, பூஜ்ஜிய வீத, விலக்கு பெற்ற விநியோகங்கள்.",
    "sourceHash": "c2fbae07",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.reason.nil": {
    "text": "பூஜ்ஜிய GST அறிக்கைகளும் தாக்கல் செய்த அறிக்கைகளாகவே கணக்கிடப்படுகின்றன; எனவே மொத்த ஆண்டு விநியோகங்கள் S$0, தேவை 1 ஏப்ரல் 2028 முதல் பொருந்தும்.",
    "sourceHash": "e238758b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.reason.extrapolate": {
    "text": "2025-இல் முடிவடையும் உங்கள் அறிக்கைகள் ஆண்டின் ஒரு பகுதியை மட்டுமே உள்ளடக்கினால், உங்கள் கட்டத்தைக் கண்டறிய விநியோகங்களை 365 நாள் சமமானதாக நீட்டிக் கணக்கிடலாம்.",
    "sourceHash": "3ae04638",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.reason.noReturns": {
    "text": "2025 நாட்காட்டி ஆண்டில் முடிவடையும் காலங்களுக்கான GST அறிக்கைகள் உங்களிடம் இல்லையென்றால், உங்கள் நடைமுறைத் தேதியை IRAS தனியாக அறிவிக்கும்.",
    "sourceHash": "75ae99d9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.reason.noReturnsPage": {
    "text": "2025-இல் முடிவடையும் காலங்களுக்கான GST அறிக்கைகள் இல்லாத வணிகங்களுக்கு, அவற்றின் நடைமுறைத் தேதி பின்னர் தெரிவிக்கப்படும்.",
    "sourceHash": "565bd55d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.reason.volFrom2026": {
    "text": "1 ஏப்ரல் 2026 அன்றோ அதற்குப் பிறகோ தன்னார்வ GST பதிவுக்கு விண்ணப்பிக்கும் வணிகங்கள், நிறுவப்பட்ட தேதி அல்லது வணிக அமைப்பு எதுவாக இருந்தாலும் இணங்க வேண்டும்.",
    "sourceHash": "d015650a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.reason.volCompulsoryApprovedAsVoluntary": {
    "text": "தன்னார்வ அடிப்படையில் அங்கீகரிக்கப்பட்ட கட்டாயப் பதிவு விண்ணப்பமும் இணங்க வேண்டும்.",
    "sourceHash": "5466caab",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.reason.newInc": {
    "text": "1 நவம்பர் 2025 முதல், நிறுவப்பட்ட 6 மாதங்களுக்குள் தன்னார்வப் பதிவுக்கு விண்ணப்பிக்கும் புதிதாக நிறுவப்பட்ட நிறுவனங்கள் இணங்க வேண்டும். விண்ணப்பத் தேதியே கணக்கில் கொள்ளப்படும், அங்கீகாரத் தேதி அல்ல.",
    "sourceHash": "e5c52505",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.reason.redomiciled": {
    "text": "சிங்கப்பூருக்குப் பதிவு மாற்றப்பட்ட நிறுவனம் புதிதாக நிறுவப்பட்டதாகக் கருதப்படாது; எனவே அது 1 நவம்பர் 2025 கட்டத்தில் இல்லை.",
    "sourceHash": "41ab4b66",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.reason.compulsory2028": {
    "text": "1 ஏப்ரல் 2028 அன்றோ அதற்குப் பிறகோ கட்டாய GST பதிவுக்கு விண்ணப்பிக்கும் வணிகங்கள் பதிவு முதல் இணங்க வேண்டும்.",
    "sourceHash": "95f33e05",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.reason.group": {
    "text": "ஏற்கெனவே உள்ள GST குழுவில் சேர்க்கப்படும் புதிய தன்னார்வ GST பதிவாளர் அந்தக் குழுவின் கட்டத்தைப் பின்பற்றுகிறார். குழுவில் உள்ள விலக்கப்பட்ட வணிகங்கள் (வெளிநாட்டு நிறுவனங்கள் போன்றவை) மட்டுமே விலைப்பட்டியல் தரவை அனுப்ப வேண்டியதில்லை.",
    "sourceHash": "62a4276e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.reason.excluded": {
    "text": "விலக்கப்பட்ட வணிகங்கள் (Excluded Business: வெளிநாட்டு நிறுவனங்கள், தலைகீழ் வரி விதிப்பு முறையால் மட்டுமே பதிவுசெய்த வணிகங்கள்) இணங்க வேண்டியதில்லை.",
    "sourceHash": "151effd7",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.reason.notRegistered": {
    "text": "இந்தத் தேவை GST பதிவு பெற்ற வணிகங்களுக்குப் பொருந்தும்.",
    "sourceHash": "f9b5c7a5",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.reason.band_p3": {
    "text": "மொத்த ஆண்டு விநியோகங்கள் ≤ S$200,000 உள்ள தற்போதைய GST பதிவு பெற்ற வணிகங்கள் 1 ஏப்ரல் 2028 முதல் இணங்க வேண்டும்.",
    "sourceHash": "94fffdf9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.reason.band_p4": {
    "text": "மொத்த ஆண்டு விநியோகங்கள் ≤ S$1,000,000 உள்ள தற்போதைய GST பதிவு பெற்ற வணிகங்கள் 1 ஏப்ரல் 2029 முதல் இணங்க வேண்டும்.",
    "sourceHash": "00a99cf3",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.reason.band_p5": {
    "text": "மொத்த ஆண்டு விநியோகங்கள் ≤ S$4,000,000 உள்ள தற்போதைய GST பதிவு பெற்ற வணிகங்கள் 1 ஏப்ரல் 2030 முதல் இணங்க வேண்டும்.",
    "sourceHash": "61ee6fb8",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.reason.band_p6": {
    "text": "மொத்த ஆண்டு விநியோகங்கள் > S$4,000,000 உள்ள தற்போதைய GST பதிவு பெற்ற வணிகங்கள் 1 ஏப்ரல் 2031 முதல் இணங்க வேண்டும்.",
    "sourceHash": "75b75ad3",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "foc.0": {
    "text": "IMDA-வின் இலவச (FOC) InvoiceNow தொகுப்புப் பட்டியலின்படி, முழுத் தீர்வுத் தொகுப்பும் எந்த நிபந்தனையும் இன்றி இலவசம்.",
    "sourceHash": "e0c56a40",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "foc.1": {
    "text": "GST பதிவு பெற்ற வணிகங்களுக்கான இலவசத் தொகுப்புகள் 31 மார்ச் 2031 வரை கிடைக்கும்.",
    "sourceHash": "ef4224e2",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "foc.2": {
    "text": "தொடக்க, முடிவுத் தேதிகள் வழங்குநருக்கு வழங்குநர் மாறுபடும்; நீங்கள் தேர்ந்தெடுக்கும் தொகுப்புக்குப் பட்டியலைச் சரிபாருங்கள்.",
    "sourceHash": "c6294c6d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.foc.amount": {
    "text": "இலவசம்",
    "sourceHash": "97a522db",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.foc.who": {
    "text": "GST பதிவு பெற்ற வணிகங்கள்",
    "sourceHash": "f0c80296",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.foc.period": {
    "text": "31 மார்ச் 2031 வரை கிடைக்கும்; தேதிகள் வழங்குநருக்கு வழங்குநர் மாறுபடும்",
    "sourceHash": "c211f3a4",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.foc.hrefLabel": {
    "text": "இலவசத் தொகுப்புப் பட்டியல்",
    "sourceHash": "9ee3fb61",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.t1k.amount": {
    "text": "S$1,000",
    "sourceHash": "2d421df5",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.t1k.who": {
    "text": "மொத்த ஆண்டு விநியோகங்கள் ≤ S$4 மில்லியன் (2025-இல் முடிவடையும் காலங்கள்)",
    "sourceHash": "ae19ad94",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.t1k.period": {
    "text": "1 ஜூலை 2026 முதல் 31 மார்ச் 2030 வரை, அல்லது முழுமையாகக் கோரப்படும் வரை",
    "sourceHash": "7c3ba131",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.t1k.hrefLabel": {
    "text": "கோரிக்கைப் படிவம்",
    "sourceHash": "00a2767f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.t1k.term.0": {
    "text": "InvoiceNow-Ready தீர்வு வழங்குநருக்கு (IRSP) சந்தா செலுத்த அல்லது IMDA அங்கீகாரம் பெற்ற Access Point மூலம் இணைக்க ரொக்க மானியம்.",
    "sourceHash": "fb34e4f6",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.t1k.term.1": {
    "text": "26 பிப்ரவரி 2026-க்குப் பிறகு IRSP தீர்வுக்குச் சந்தா செலுத்துங்கள் (குறைந்தது 12 மாதங்களுக்குக் கட்டணம்), அல்லது உங்கள் ERP-ஐ அங்கீகாரம் பெற்ற Access Point உடன் ஒருங்கிணையுங்கள்.",
    "sourceHash": "a0c5bbcc",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.t1k.term.2": {
    "text": "சேருவதற்கு முந்தைய 3 மாதங்களில் ஏதேனும் IRSP தீர்வைப் பயன்படுத்தியிருந்தால் இது கிடைக்காது.",
    "sourceHash": "f5885c0d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.t1k.term.3": {
    "text": "உங்கள் கட்டாயக் காலக்கெடுவுக்கு முன் GST InvoiceNow-ஐச் செயல்படுத்தி, IRAS-க்குத் தரவைச் சமர்ப்பிக்க வேண்டும்.",
    "sourceHash": "33ddaf12",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.t5k.amount": {
    "text": "S$5,000",
    "sourceHash": "14515e89",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.t5k.who": {
    "text": "மொத்த ஆண்டு விநியோகங்கள் > S$4 மில்லியன் (2025-இல் முடிவடையும் காலங்கள்), சொந்த ERP உடன்",
    "sourceHash": "57f19348",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.t5k.period": {
    "text": "1 ஜூலை 2026 முதல் 31 மார்ச் 2028 வரை, அல்லது முழுமையாகக் கோரப்படும் வரை",
    "sourceHash": "a0cd6aa0",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.t5k.hrefLabel": {
    "text": "ஆர்வ அறிவிப்பு (Expression of interest)",
    "sourceHash": "a8fdb5ae",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.t5k.term.0": {
    "text": "IMDA அங்கீகாரம் பெற்ற Access Point மூலம் உங்கள் சொந்த ERP-ஐ GST InvoiceNow உடன் இணைக்க ரொக்க மானியம்.",
    "sourceHash": "f972f0b2",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.t5k.term.1": {
    "text": "26 பிப்ரவரி 2026-க்குப் பிறகு திட்டத்தைத் தொடங்கி, 12 மாதங்களுக்குள் முடித்து, 31 மார்ச் 2028-க்குள் GST InvoiceNow-ஐச் செயல்படுத்தி IRAS-க்கு விலைப்பட்டியல் தரவைச் சமர்ப்பியுங்கள்.",
    "sourceHash": "c8e4eb5d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.t5k.term.2": {
    "text": "முதலில் Expression of Interest (ஆர்வ அறிவிப்பு) சமர்ப்பித்து, அனைத்து நிபந்தனைகளையும் பூர்த்திசெய்த பின் கோரலாம்.",
    "sourceHash": "06b50f7d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.queenBee.amount": {
    "text": "S$25,000",
    "sourceHash": "527e6ba3",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.queenBee.who": {
    "text": "ஆண்டு வருவாய் > S$4 மில்லியன், சொந்தத் தனிப்பயன் ERP உடன்",
    "sourceHash": "beb5790b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.queenBee.period": {
    "text": "1 ஜூலை 2026 முதல் 31 மார்ச் 2030 வரை, அல்லது முழுமையாகக் கோரப்படும் வரை",
    "sourceHash": "7c3ba131",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.queenBee.hrefLabel": {
    "text": "ஆர்வ அறிவிப்பு (Expression of interest)",
    "sourceHash": "a8fdb5ae",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.queenBee.term.0": {
    "text": "உங்கள் சொந்தத் தனிப்பயன் ERP-ஐ InvoiceNow உடன் இணைத்து, அதில் உங்கள் வணிகப் பங்காளிகளுடன் பரிவர்த்தனை செய்ய.",
    "sourceHash": "866c9f97",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.queenBee.term.1": {
    "text": "குறைந்தது 200 விற்பனையாளர்கள் அல்லது 200 வணிக வாடிக்கையாளர்கள் தேவை; 31 மார்ச் 2031-க்குள் InvoiceNow மூலம் குறைந்தது 20 விற்பனையாளர்களிடமிருந்து பெற வேண்டும் அல்லது குறைந்தது 40 வாடிக்கையாளர்களுக்கு அனுப்ப வேண்டும்.",
    "sourceHash": "6e7cf731",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.queenBee.term.2": {
    "text": "S$5,000 Transition Grant உடன் இணைத்துப் பெறலாம்.",
    "sourceHash": "2f0cb8f3",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grants.psg": {
    "text": "தகுதியான மென்பொருள் சந்தாச் செலவுகளில் 50% வரை ஈடுசெய்ய, சிறு, நடுத்தர நிறுவனங்கள் (SME) Productivity Solutions Grant-ஐயும் பயன்படுத்தலாம்.",
    "sourceHash": "d6dd2dfc",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "software.irspCount": {
    "text": "IMDA-வின் InvoiceNow-Ready தீர்வு வழங்குநர் பட்டியல் (12 அக்டோபர் 2026 அன்று புதுப்பிக்கப்பட்டது) 81 வழங்குநர்களையும், மறுவிற்பனையாளர்களையும் குறிப்பிடுகிறது.",
    "sourceHash": "7a5927d7",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "vendor.inHouseConnect": {
    "text": "உள்ளக நிறுவனத் தீர்வுகளுக்கு, IRAS-உடன் அமைப்பை இணைக்க 3 முதல் 12 மாதங்கள் ஒதுக்குங்கள்.",
    "sourceHash": "df11b6c4",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "benefit.0.lead": {
    "text": "சீரானது",
    "sourceHash": "1c9ecb39",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "benefit.0.text": {
    "text": "விலைப்பட்டியல்கள் நிதி அமைப்புகளுக்கு இடையே கட்டமைக்கப்பட்ட தரவாகச் செல்கின்றன; கைமுறையாக அனுப்புதல், பெறுதல், மீண்டும் தட்டச்சு செய்தல் இல்லை.",
    "sourceHash": "17223d30",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "benefit.1.lead": {
    "text": "குறைவான பிழைகள்",
    "sourceHash": "c89722c9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "benefit.1.text": {
    "text": "கைமுறை வேலை குறைவதால் பிழைகளும் திருத்தச் செலவுகளும் குறைகின்றன; சேமிப்பு, தேடல் செலவுகளும் குறைகின்றன.",
    "sourceHash": "9f1a5b7a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "benefit.2.lead": {
    "text": "GST சரிபார்ப்புகள்",
    "sourceHash": "40d0c5f2",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "benefit.2.text": {
    "text": "GST பதிவு பெறாத விற்பனையாளர்கள் தவறாக GST விதித்தால் உங்களை எச்சரிக்கும் சரிபார்ப்புகளை InvoiceNow-Ready தீர்வுகளில் உள்ளமைக்கலாம்.",
    "sourceHash": "5e3dbd1c",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "benefitStat.0.lead": {
    "text": "சேமிப்பு",
    "sourceHash": "dc787b50",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "benefitStat.0.text": {
    "text": "கைமுறைச் செயலாக்கம் குறைவதால் வணிகங்கள் ஒவ்வொரு விலைப்பட்டியலுக்கும் $20 வரை சேமிக்கலாம்.",
    "sourceHash": "4f67845a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "benefitStat.1.lead": {
    "text": "பிழை விகிதம்",
    "sourceHash": "c30963ee",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "benefitStat.1.text": {
    "text": "மின்-விலைப்பட்டியல் விலைப்பட்டியல் பிழை விகிதங்களை 50% வரை குறைக்கும் என்றும் ஆய்வுகள் காட்டுகின்றன.",
    "sourceHash": "b0fff20f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.0.group": {
    "text": "IRAS",
    "sourceHash": "7be84b1e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.0.0.why": {
    "text": "அதிகாரபூர்வ பக்கம்: யார் சேர வேண்டும், தேதிகள், என்ன செய்வது.",
    "sourceHash": "a19554a1",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.0.1.why": {
    "text": "GST பதிவு பெற்ற வணிகங்களுக்கான முழு வழிகாட்டி, நான்கு சமர்ப்பிப்பு வகைகள் உட்பட.",
    "sourceHash": "c24f442e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.0.2.why": {
    "text": "வணிகங்களின் பொதுவான கேள்விகளுக்கு விரிவான பதில்கள்.",
    "sourceHash": "7edaf727",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.0.3.why": {
    "text": "உங்கள் நடைமுறைத் தேதியைச் சரிபார்க்க IRAS-இன் சொந்த விரிதாள்.",
    "sourceHash": "f017ed20",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.0.4.why": {
    "text": "இந்தத் தேவை உங்கள் வணிகத்துக்கு எப்படிப் பொருந்தும் என்று IRAS-இடம் கேளுங்கள்.",
    "sourceHash": "ea023a06",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.0.5.why": {
    "text": "InvoiceNow-Ready தீர்வு வழங்குநர்கள் நடத்தும், IRAS பட்டியலிட்ட நிகழ்வுகள்.",
    "sourceHash": "9d236c3a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.1.group": {
    "text": "IMDA",
    "sourceHash": "ca38b594",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.1.0.why": {
    "text": "InvoiceNow, வலையமைப்பு, அதன் பயன்கள் பற்றி.",
    "sourceHash": "2396384d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.1.1.why": {
    "text": "இலவசத் தொகுப்பும் S$1k, S$5k, Queen Bee மானியங்களும், கோரிக்கைப் படிவங்களுடன்.",
    "sourceHash": "2612fe7a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.1.2.why": {
    "text": "மானியத் தகுதியும் காலக்கெடுக்களும் பற்றிய ஒரு பக்கச் சுருக்கம்.",
    "sourceHash": "b16a1d7d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.1.3.why": {
    "text": "மானியங்களுக்கு யார் தகுதியானவர்கள், அவற்றை எப்படிக் கோருவது.",
    "sourceHash": "a969c667",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.1.4.why": {
    "text": "விலைப்பட்டியல்களை அனுப்பவும் பெறவும் IRAS-க்குத் தெரிவிக்கவும் நீங்கள் பயன்படுத்தக்கூடிய அங்கீகாரம் பெற்ற மென்பொருள்.",
    "sourceHash": "cf1739ee",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.1.5.why": {
    "text": "சொந்த ERP அல்லது உள்ளக அமைப்புள்ள வணிகங்களுக்கான அங்கீகாரம் பெற்ற Access Point வழங்குநர்கள்.",
    "sourceHash": "80ed385f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.1.6.why": {
    "text": "GST பதிவு பெற்ற வணிகங்களுக்கான இலவசத் தீர்வுத் தொகுப்புகள், ஒவ்வொரு வழங்குநரின் தேதிகளுடன்.",
    "sourceHash": "5035af93",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.1.7.why": {
    "text": "இலவசத் தீர்வு வழங்குநர் உங்களை அழைக்குமாறு கேளுங்கள்.",
    "sourceHash": "f57ad21b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.1.8.why": {
    "text": "InvoiceNow, மானியங்கள் பற்றி IMDA-விடம் கேளுங்கள்.",
    "sourceHash": "2238ebe6",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.2.group": {
    "text": "மேலும் அறிய",
    "sourceHash": "d517a63a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.2.0.why": {
    "text": "தேவைக்குத் தயாராவது பற்றிய IRAS-IMDA இணையக் கருத்தரங்குகள்.",
    "sourceHash": "efd6e4ff",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.2.1.why": {
    "text": "ஒரு வணிகம் InvoiceNow வலையமைப்பில் உள்ளதா என்று தேடுங்கள்.",
    "sourceHash": "dd4bd766",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "help.0.group": {
    "text": "அதிகாரபூர்வ கேள்வி-பதில்களைப் படியுங்கள்",
    "sourceHash": "274bf870",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "help.0.0.why": {
    "text": "தேவை பற்றிய கேள்விகள், 23 செப்டம்பர் 2026 பதிப்பு.",
    "sourceHash": "5db27b8b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "help.0.1.why": {
    "text": "தகுதியும் கோரிக்கைகளும்.",
    "sourceHash": "9f9bbe9a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "help.1.group": {
    "text": "உங்கள் சொந்த விஷயம் பற்றிய கேள்விகள்",
    "sourceHash": "35540ec6",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "help.1.0.why": {
    "text": "இந்தத் தேவை உங்கள் வணிகத்துக்கு எப்படிப் பொருந்தும் என்று IRAS-இடம் கேளுங்கள்.",
    "sourceHash": "a687ae87",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "help.1.1.why": {
    "text": "InvoiceNow, வலையமைப்பு, மானியங்கள் பற்றி IMDA-விடம் கேளுங்கள்.",
    "sourceHash": "88920956",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "help.2.group": {
    "text": "வழங்குநரைத் தேடுகிறீர்களா?",
    "sourceHash": "d32a0c7c",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "help.2.0.why": {
    "text": "இலவசத் தீர்வு வழங்குநர் உங்களை அழைக்கக் கோருங்கள்.",
    "sourceHash": "85f05924",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "help.2.1.why": {
    "text": "நீங்கள் சேரக்கூடிய வழங்குநர் நடத்தும் நிகழ்வுகள்.",
    "sourceHash": "29248e22",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-20.6.title": {
    "text": "மானியங்களுக்கும் அமைப்புக்கும் தனிப் பக்கங்கள்",
    "sourceHash": "0988e2b2",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-20.6.0": {
    "text": "புதிய மானியங்கள் பக்கம்: S$1,000, S$5,000 GST InvoiceNow மாற்ற மானியங்கள், S$25,000 Queen Bee மானியம், உற்பத்தித்திறன் தீர்வுகள் மானியம், தொடர்புடைய கேள்வி-பதில்களுடன்.",
    "sourceHash": "550aa9fe",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-20.6.1": {
    "text": "மென்பொருள் மற்றும் மானியங்கள் பக்கம் இப்போது இலவசத் தொகுப்பு, வழங்குநர் பட்டியல்கள், “எனக்கு எது பொருந்தும்?” உதவிக் கருவி ஆகியவற்றை உள்ளடக்கி, மானியங்கள் பக்கத்துக்கு இணைப்பு தருகிறது.",
    "sourceHash": "c308dd08",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-20.6.2": {
    "text": "புதிய அமைப்பு வழிகாட்டி: சரிபார்ப்புப் பட்டியலின் ஐந்து படிகளும் ஒரே பக்கத்தில், ஒவ்வொன்றும் அதிகாரப்பூர்வ மூலங்களுடன், Peppol ID தேடல், InvoiceNow-ஐப் பயன்படுத்த எங்கே உள்நுழைவது.",
    "sourceHash": "7b1f25ae",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-20.6.3": {
    "text": "மென்பொருள் மற்றும் மானியங்கள்: பிரபலக் கணக்கியல் மென்பொருள்கள் (Xero, AutoCount, ABSS, SAP Business One, QuickBooks மற்றும் பிற) IMDA-வின் 12 அக்டோபர் 2026 InvoiceNow-Ready தீர்வு வழங்குநர் பட்டியலில் உள்ளனவா என்று காட்டும் அட்டவணை.",
    "sourceHash": "b3359b0e",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-20.6.4": {
    "text": "தெளிவான பக்கத் தலைப்புகள்.",
    "sourceHash": "bce15627",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.5.title": {
    "text": "மொழித் தேர்வு, சரிபார்ப்புப் பட்டியல் இணைப்புகள் மற்றும் முகப்புப் பக்க எண்ணிக்கைகள்",
    "sourceHash": "ca71b95b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.5.0": {
    "text": "சீன, மலாய் மற்றும் தமிழ்ப் பக்கங்கள் இப்போது வரைவு மொழிபெயர்ப்புகளாகக் கிடைக்கின்றன; தாய்மொழி பேசுபவர் சரிபார்க்கும் வரை அவை தெளிவாகக் குறிக்கப்படும். எந்தப் பக்கத்தின் மேலேயும் மொழியைத் தேர்ந்தெடுக்கலாம்.",
    "sourceHash": "ea952d87",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.5.1": {
    "text": "சரிபார்ப்புப் பட்டியலின் ஒவ்வொரு படியும் இப்போது இந்தத் தளத்திலுள்ள பொருத்தமான பக்கம் அல்லது கருவியுடன் இணைக்கப்பட்டுள்ளது.",
    "sourceHash": "0244a948",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.5.2": {
    "text": "முகப்புப் பக்க நன்மைகளில் இப்போது இரண்டு முக்கிய எண்ணிக்கைகள் உள்ளன: ஒவ்வொரு விலைப்பட்டியலுக்கும் $20 வரை சேமிப்பு, மற்றும் விலைப்பட்டியல் பிழை விகிதங்கள் 50% வரை குறைவு.",
    "sourceHash": "0867745b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.5.3": {
    "text": "“இலவச மென்பொருள்” பக்கம் இப்போது “மென்பொருளும் மானியங்களும்” எனப் பெயர் மாற்றப்பட்டுள்ளது; புதிய “எனக்கு எந்த விருப்பம் பொருந்தும்?” கருவியும் உள்ளது. ஒவ்வொரு பக்கத்தின் மேலேயுள்ள “நான் என்ன செய்ய வேண்டும்?” பொத்தான் சரிபார்ப்புப் பட்டியலைத் திறக்கும்.",
    "sourceHash": "b845a176",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.4.title": {
    "text": "சீன, மலாய், தமிழ்ப் பதிப்புகள் தயாரிக்கப்பட்டன",
    "sourceHash": "2b37db34",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.4.0": {
    "text": "இந்தத் தளத்தை இப்போது எளிய சீனம், மலாய், தமிழில் காட்டலாம். மொழிபெயர்ப்புகள் அதிகாரபூர்வமற்றவை; ஆங்கிலப் பதிப்பே மேலோங்கும்.",
    "sourceHash": "b1ce89f1",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.4.1": {
    "text": "ஒரு பக்கத்தின் ஒவ்வொரு வாக்கியத்தையும் தாய்மொழியாளர் சரிபார்த்த பிறகே அந்தப் பக்கம் அந்த மொழியில் வெளியிடப்படும்.",
    "sourceHash": "78d0cacb",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.3.title": {
    "text": "தலைப்புவாரிப் பக்கங்களாகப் பிரிக்கப்பட்டது",
    "sourceHash": "1bad2e23",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.3.0": {
    "text": "நீண்ட முகப்புப் பக்கம் இப்போது சரிபார்ப்புப் பட்டியலுடன் கூடிய சுருக்கமான கண்ணோட்டம். தேதிகளும் கணிப்பானும், இலவச மென்பொருளும் மானியங்களும், செயல்படும் முறை, POS மற்றும் சில்லறை, கேள்வி-பதில் ஒவ்வொன்றுக்கும் தனிப் பக்கம் உள்ளது.",
    "sourceHash": "e829e950",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.2.title": {
    "text": "IRAS கேள்வி-பதிலிலிருந்து புதிய பதில்கள், மேலும் துல்லியமான தேதிக் கணிப்பான்",
    "sourceHash": "0b41e916",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.2.0": {
    "text": "புதிய கேள்வி-பதில்கள்: POS, தொகுத்த விற்பனை, சமர்ப்பிப்புக் காலக்கெடு, ஒப்புகை எண்கள், மீண்டும் சமர்ப்பித்தலும் கடன் குறிப்புகளும், GST குழுப் பதிவு, InvoiceNow-வில் இல்லாத வாடிக்கையாளர்கள், அபராதங்கள்.",
    "sourceHash": "48230640",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.2.1": {
    "text": "தேதிக் கணிப்பான் இப்போது IRAS கேள்வி-பதில் Q1.5 முதல் Q1.12, Q7.2 ஆகியவற்றைப் பின்பற்றுகிறது: நாட்காட்டி அல்லாத கணக்கியல் காலங்கள், பூஜ்ஜிய அறிக்கைகள், பகுதி ஆண்டு அறிக்கைகள், தன்னார்வ, புதிய கட்டாயப் பதிவாளர்கள், பதிவு மாற்றப்பட்ட நிறுவனங்கள், விலக்கப்பட்ட வணிகங்கள், GST குழுக்கள்.",
    "sourceHash": "cad24b17",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.1.title": {
    "text": "சுயாதீனத்தன்மையும் மூலங்களும் மேலும் தெளிவாக",
    "sourceHash": "1b786b97",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.1.0": {
    "text": "இந்தத் தளம் சுயாதீனமானது, IRAS அல்லது IMDA உடன் தொடர்பில்லை என்று கூறும் பதாகையுடன் ஒவ்வொரு பக்கமும் இப்போது தொடங்குகிறது.",
    "sourceHash": "bff02dff",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.1.1": {
    "text": "புதிய பற்றி பக்கம்: தளம் ஏன் உள்ளது, உள்ளடக்கம் எப்படிச் சரிபார்க்கப்படுகிறது, தனியுரிமை.",
    "sourceHash": "37457db6",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.1.2": {
    "text": "புதிய பொது மாற்றப் பதிவு (இந்தப் பக்கம்).",
    "sourceHash": "e84748e0",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.1.3": {
    "text": "உள்ளடக்கம் அதிகாரபூர்வ மூலங்களுடன் கடைசியாகச் சரிபார்க்கப்பட்ட தேதியை முகப்புப் பக்கம் காட்டுகிறது.",
    "sourceHash": "34039bc5",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.0.title": {
    "text": "சமீபத்திய IRAS, IMDA மூலங்களுடன் உள்ளடக்கம் சரிபார்க்கப்பட்டது",
    "sourceHash": "7658597f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.0.0": {
    "text": "இலவசத் தொகுப்பு: இப்போது 17 செப்டம்பர் 2026 தேதியிட்ட IMDA பட்டியலைப் பின்பற்றுகிறது (நிபந்தனையின்றி இலவசம், 31 மார்ச் 2031 வரை கிடைக்கும், தேதிகள் வழங்குநருக்கு வழங்குநர் மாறுபடும்). சில வழங்குநர்கள் பயன்பாட்டுக்கு அல்லது சந்தா மூலம் கட்டணம் வசூலிக்கிறார்கள் என்ற மூலமில்லாத வரி நீக்கப்பட்டது.",
    "sourceHash": "5bb75433",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.0.1": {
    "text": "விலக்குகள்: “விலக்குக் கோரிக்கைகள் நிராகரிக்கப்படும்” என்பதற்குப் பதிலாக IRAS கேள்வி-பதில் Q2.6, Q1.14 உண்மையில் கூறுவது சேர்க்கப்பட்டது.",
    "sourceHash": "c9587149",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.0.2": {
    "text": "மூலங்கள் இப்போது ஒவ்வொரு வாக்கியத்துக்கும் கேள்வி எண்கள், e-Tax Guide பத்திகளுடன் குறிப்பிடப்படுகின்றன.",
    "sourceHash": "9d9ae8f1",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.0.3": {
    "text": "அதிகாரபூர்வ மூலத்தில் கண்டறிய முடியாத மூன்று முகப்புப் பக்கப் புள்ளிவிவரங்கள் (ஒரு விலைப்பட்டியலுக்கான சேமிப்பு, கட்டண வேகம், பிழை விகிதங்கள்) நீக்கப்பட்டன.",
    "sourceHash": "f2596592",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.0.4": {
    "text": "உள்ளக அமைப்பை இணைக்க 3 முதல் 12 மாதங்கள் என்ற வழிகாட்டல் இப்போது e-Tax Guide பத்தி 13.6-ஐ மேற்கோள் காட்டுகிறது.",
    "sourceHash": "aa9c55a2",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  }
}
